class AlertReasonsForRefusal {
  constructor (lastTransaction) {
    this.lastTransaction = lastTransaction
  }

  NAO_AUTORIZADO = 'Não autorizado'
  CANCELADO = 'Cancelado'
  FALHA = 'Falha'
  VARIANT_WARNING = 'warning'
  LINK_REFUSED_REASON =
    'https://pagarme.helpjuice.com/p2-manual-da-dashboard/dashboard-como-identificar-o-motivo-da-falha-em-uma-cobran%C3%A7a?from_search=134618702'

  antiFraud ({ status, anti_fraud }) {
    return {
      message: 'antiFraud.message',
      variant: this.VARIANT_WARNING,
      link: {
        text: 'antiFraud.link',
        href: this.LINK_REFUSED_REASON,
        target: '_blank'
      },
      condition:
        (status === this.NAO_AUTORIZADO || status === this.CANCELADO) &&
        anti_fraud?.status === 'reproved'
    }
  }

  acquirer ({
    status,
    acquirer_return_code: acquirerReturnCode,
    acquirer_message: acquirerMessage
  }) {
    return {
      message: 'acquirer.message',
      variant: this.VARIANT_WARNING,
      link: {
        text: 'acquirer.link',
        href: this.LINK_REFUSED_REASON,
        target: '_blank'
      },
      params: {
        acquirerMessage,
        acquirerReturnCode,
        message: 'acquirer.paramsText'
      },
      condition:
        status === this.NAO_AUTORIZADO &&
        !!(acquirerReturnCode && acquirerMessage)
    }
  }

  gateway ({ status, gateway_response: gatewayResponse }) {
    return {
      message: 'gateway.message',
      variant: this.VARIANT_WARNING,
      link: {
        text: 'gateway.link',
        href: this.LINK_REFUSED_REASON,
        target: '_blank'
      },
      params: gatewayResponse?.errors[0]?.message,
      condition: status === this.FALHA && !!gatewayResponse?.errors
    }
  }

  genericFail ({ status, gateway_response: gatewayResponse }) {
    return {
      message: 'genericFail.message',
      variant: this.VARIANT_WARNING,
      link: {
        text: 'genericFail.link',
        href: this.LINK_REFUSED_REASON,
        target: '_blank'
      },
      condition: status === this.FALHA
    }
  }

  getAlerts () {
    return [
      this.antiFraud(this.lastTransaction),
      this.acquirer(this.lastTransaction),
      this.gateway(this.lastTransaction),
      this.genericFail(this.lastTransaction)
    ]
  }
}

export default AlertReasonsForRefusal
